// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const CreateChoreStep1 = require('components/cards/cardOpenYoung/cardOpenYoungCreateChoreSteps/createChoreStep1/createChoreStep1')
const CreateChoreStep2 = require('components/cards/cardOpenYoung/cardOpenYoungCreateChoreSteps/createChoreStep2/createChoreStep2')
const CreateChoreFinalStep = require('components/cards/cardOpenYoung/cardOpenYoungCreateChoreSteps/createChoreFinalStep/createChoreFinalStep')
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');

// @constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');

// @actions
const openYoungCardCreateChoreAction = require('actions/openYoungCardCreateChore');

class OpenYoungCardCreateChoresView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.goToMovementsPage = this.goToMovementsPage.bind(this);
    }

    componentWillMount() {
        this.props.reset();
        this.props.getChoresList();
    }

    componentDidMount() {
        const { immCards, match: { params: { cardId } }, setTotalAvailableBalance } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        setTotalAvailableBalance(immCard.getIn(['availableBalance', 'amount']));
    }
    goToMovementsPage() {
        const { match: { params: { cardId } }, history } = this.props;

        history.push(`/myprofile/cards/${cardId}/movements`);
    }

    handleCancel() {
        const { cardId } = this.props.match.params;
        this.props.history.push(`/myprofile/cards/${cardId}/chores`);
    }

    handleFinish() {
        const { match: { params: { cardId } }, immCards, immOpenYoungCardCreateChore } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const step =  immOpenYoungCardCreateChore.get('steps').get(0);
        this.props.handleFinish(immCard, step);
    }

    buildWizard(immCard) {
        const {
            conceptChanged,
            handleAmountChange,
            immOpenYoungCardCreateChore,
            setChoreType,
            setVisibleStep,
            setWillCancel,
            validateStep,
            validityDateChanged,
            setRepetitionType,
            setRepetitionOptionsList
        } = this.props;
        const immSteps = immOpenYoungCardCreateChore.get('steps');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                showPreLeaveModal={true}
                stepsAmount={immSteps.size}
                visibleStep={immOpenYoungCardCreateChore.get('visibleStep')}>
                <WizardStep position="first" cancelButton={true} >
                    <CreateChoreStep1
                        conceptChanged={conceptChanged}
                        handleAmountChange={handleAmountChange}
                        immCard={immCard}
                        immStep={immOpenYoungCardCreateChore.get('steps').get(0)}
                        immOpenYoungCardCreateChore={immOpenYoungCardCreateChore}
                        setChoreType={setChoreType}
                        validityDateChanged={validityDateChanged}
                        setRepetitionType={setRepetitionType}
                        setRepetitionOptionsList={setRepetitionOptionsList}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={false}
                    cancelButton={true}
                    immFinalButton="openYoungCreateChores-confirm"
                    position="last">
                    <CreateChoreStep2
                        immCard={immCard}
                        immOpenYoungCardCreateChore={immOpenYoungCardCreateChore.get('steps').get(0)}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    buildSuccessful() {
        const { match: { params: { cardId } }, immOpenYoungCardCreateChore, immCards} = this.props;
        const immCard = immCards.get('byId').get(cardId);

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-10">
                <CreateChoreFinalStep
                    errorState={immOpenYoungCardCreateChore.get('submitError')}
                    immOpenYoungCardCreateChore={immOpenYoungCardCreateChore.get('steps').get(0)}
                    immCard={immCard}
                />
            </div>
        )
    }

    render() {
        const { match: { params: { cardId } }, immCards, immOpenYoungCardCreateChore } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        let content;
        let bodyContent;

        if (immCards.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-openYoungChores'),
                    url: `/myprofile/cards/${cardId}/chores`
                },
                {
                    text: formatText('breadcrumb-openYoungCreateChores')
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText('tutorials-openYoungCreateChoreTitle')}
                />
            );
            if (immOpenYoungCardCreateChore.get('submitSuccessful') || immOpenYoungCardCreateChore.get('submitError')) {
                bodyContent = this.buildSuccessful(immCard);
            } else {
                const wizard = this.buildWizard(immCard);
                bodyContent = (
                    <div className="row no-outside-gutter">
                        <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        <div className="col-md-12 col-lg-8">
                            {wizard}
                        </div>
                        <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                    </div>
                );
            }
                content = (
                    <div className="open-young-management">
                        <div className="container-fluid">
                            <div className="row">
                                <OKCover size="medium" section="cards" customClass="col-xs-12">
                                    <OKHeaderSubPage
                                        breadcrumbConfig={mappingBreadcrumb}
                                        tutorial={tutorial}
                                        finalTitle={getFinalTitle('openYoungCreateChores-title')}
                                        subtitleLeft={subtitleLeft}
                                        subtitleRight={subtitleRight}
                                    >
                                    </OKHeaderSubPage>
                                </OKCover>
                            </div>
                        </div>
                        <div className="grid-view__body">
                            <div className="container-fluid">
                                <div className="row grid-view--content-position-negative">
                                    {bodyContent}
                                </div>
                            </div>
                        </div>
                    </div>
                );

    }

        return content;
    }
}
OpenYoungCardCreateChoresView.propTypes = {
    conceptChanged: PropTypes.func.isRequired,
    getChoresList: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immOpenYoungCardCreateChore: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    setChoreType: PropTypes.func.isRequired,
    setRepetitionOptionsList: PropTypes.func.isRequired,
    setRepetitionType: PropTypes.func.isRequired,
    setTotalAvailableBalance: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired
};
module.exports.constructor = OpenYoungCardCreateChoresView;
module.exports.OpenYoungCardCreateChoresView = connect(
    state => ({
        immCards: state.cards,
        immOpenYoungCardCreateChore: state.openYoungCardCreateChore
    }), {
        conceptChanged: openYoungCardCreateChoreAction.conceptChanged,
        getChoresList: openYoungCardCreateChoreAction.getChoresList,
        handleAmountChange: openYoungCardCreateChoreAction.setAmount,
        handleFinish: openYoungCardCreateChoreAction.postChoreConfirm,
        reset: openYoungCardCreateChoreAction.reset,
        setChoreType: openYoungCardCreateChoreAction.setChoreType,
        setRepetitionOptionsList: openYoungCardCreateChoreAction.setRepetitionOptionsList,
        setRepetitionType: openYoungCardCreateChoreAction.setRepetitionType,
        setTotalAvailableBalance: openYoungCardCreateChoreAction.setTotalAvailableBalance,
        setVisibleStep: openYoungCardCreateChoreAction.setVisibleStep,
        setWillCancel: openYoungCardCreateChoreAction.setWillCancel,
        validateStep: openYoungCardCreateChoreAction.validateStep,
        validityDateChanged: openYoungCardCreateChoreAction.validityDateChanged
    })(withRouter(OpenYoungCardCreateChoresView));

